import React from "react";
import "./Refund.scss";



const Refund = () => (

  <div className="refund-container">
    <h1 className="heading">Refunds</h1>
    <h2>Effective Date: 1st May 2025</h2>

<p>At Aerial Borne, we understand that operational changes and scheduling conflicts can occur. To maintain fairness for both <strong>customers</strong> and <strong>certified drone operators</strong>, this policy outlines how cancellations and refund requests are handled.</p>

<p>Please read carefully before booking or accepting any project on the platform.</p>



<h2>1. General Principles</h2>
<ul>
  <li>All refund requests are reviewed case-by-case.</li>
  <li>We aim to resolve disputes impartially and professionally.</li>
  <li>Full or partial refunds may be issued depending on project status, timeline, and terms agreed between both parties.</li>
  <li>Aerial Borne acts as a neutral facilitator; final discretion lies with our dispute resolution team.</li>
</ul>



<h2>2. Customer-Initiated Cancellations</h2>
<h4>a. Before Operator Confirmation</h4>
<ul>
  <li>✅ <strong>Full refund</strong> issued automatically</li>
  <li>No cancellation fees apply</li>
</ul>

<h4>b. After Operator Confirmation but Before Execution Begins</h4>
<ul>
  <li>❗ <strong>Partial refund</strong> (platform and scheduling fees may be deducted)</li>
  <li>Operator compensation for lost opportunity may apply</li>
</ul>

<h4>c. After Execution Has Begun (Operator Dispatched or In-Flight)</h4>
<ul>
  <li>❌ <strong>No refund</strong> unless:
    <ul>
      <li>Operator fails to complete the agreed scope</li>
      <li>Safety concerns or technical failures beyond customer’s control</li>
    </ul>
  </li>
</ul>



<h2>3. Operator-Initiated Cancellations</h2>
<p>Operators are expected to honor all confirmed bookings. If cancellation is necessary:</p>
<ul>
  <li>Must notify customer and platform at least <strong>24 hours in advance</strong></li>
  <li>Aerial Borne may attempt to reassign the project</li>
  <li>✅ <strong>Full refund</strong> will be issued to the customer</li>
  <li>Operator performance rating may be affected</li>
</ul>



<h2>4. Weather or Regulatory Interruptions</h2>
<p>We operate in a field subject to environmental and regulatory constraints. In such cases:</p>
<ul>
  <li>If flight cannot proceed due to unsafe weather or DGCA airspace restrictions:
    <ul>
      <li>The project may be <strong>rescheduled</strong> at no additional cost</li>
      <li>If rescheduling is not possible, ✅ <strong>full refund</strong> may be issued</li>
      <li>Platform fees are waived in these cases</li>
    </ul>
  </li>
</ul>



<h2>5. Service Quality and Disputes</h2>
<p>If you are not satisfied with the quality or completeness of service:</p>
<ul>
  <li>Contact Aerial Borne Support within <strong>48 hours</strong> of project completion</li>
  <li>Provide documentation: project brief, images delivered, correspondence</li>
  <li>We may request feedback from both parties</li>
  <li>Resolution options include:
    <ul>
      <li>Partial refund</li>
      <li>Redo of work (if operator agrees)</li>
      <li>Platform mediation and final arbitration</li>
    </ul>
  </li>
</ul>



<h2>6. Non-Refundable Items</h2>
<p>Refunds will <strong>not</strong> be granted for:</p>
<ul>
  <li>Projects completed as per agreement, but not subjectively meeting personal preferences</li>
  <li>Cancellations after deliverables have been submitted</li>
  <li>Customer unavailability or access issues at the site</li>
  <li>Any direct agreements made outside the Aerial Borne platform</li>
</ul>



<h2>7. Refund Process and Timelines</h2>
<ul>
  <li>Refunds are issued via the original payment method</li>
  <li>Processing may take <strong>5–7 business days</strong> after approval</li>
  <li>You will receive email confirmation once initiated</li>
</ul>



<h2>8. Contact for Refund Requests</h2>
<p>For cancellations or refund-related queries, please contact:</p>
<p><strong>Aerial Borne Support Team</strong></p>

<p>📩 Email: <a href="mailto:support@aerialborne.com">support@aerialborne.com</a></p>
<p>📞 Phone: +91-7357017420</p>
<p>📍 Address: <strong>2nd Floor Plot No.4, Minarch Tower Sector-44, Gurgaon, Haryana, India, <a href="https://www.falconebiz.com/company/122003.html" target="_blank">122003</a></strong></p>



<h2>9. Policy Updates</h2>
<p>We may revise this policy as needed. Updates will be communicated via email or in-platform notices. The latest version will always apply to new bookings and disputes.</p>

 
  </div>

);

export default Refund;
